<template>
  <div class="switchWrapper">
<!--    <label>{{toggled}}}</label>-->
    <label role="checkbox" :class="['switch', { toggled }]">

      <input type="checkbox" class="switch-input" @change="toggle" />

      <div class="switch-core" :style="{backgroundColor: toggled ? colorChecked  : colorUnchecked}">
        <div class="switch-button" :style="{transition: `transform ${speed}ms`, transform: toggled ? null: `translate3d(32px, 0px, 0px)`}"></div>
      </div>

      <span class="switch-label label-right" v-if="toggled" v-html="labelChecked"></span>
      <span class="switch-label label-left"  v-html="labelUnchecked" v-else></span>

    </label>
  </div>

</template>

<script>
import request from "../../axios/axiosconfig";

export default {
  name: 'ToggleSwitch',
  data () {
    return {
      toggled: this.markToggled,
      colorChecked: '#db572e',
      colorUnchecked: '#25b9e9',
      labelChecked: '坏',
      labelUnchecked: '好'
    }
  },
  watch: {
    markToggled (curVal, oldVla) {
      console.log("ononon")
      this.toggled = curVal
    }
  },
  props: {
    markToggled: {
      type: Boolean,
      default: false
    },
    powerBoxId: {
      type: String
    },
    powerSlot: {
      type: Number
    },
    speed: {
      type: Number,
      default: 100
    }
  },
  methods: {
    toggle (event) {
      console.log("ininin")
      return request({
        url: '/ps/deviceManagement/markDeviceDestory',
        method: 'put',
        params: {
          'powerBoxId': this.powerBoxId,
          'slot': this.powerSlot,
          'destroyFlag': !this.toggled
        }
      }).then(result => {
          if (result.code === '000000') {
              if (this.toggled) {
                this.$message.success('槽位标记解除成功')
              } else {
                this.$message.success('槽位标记损坏成功')
              }
              this.toggled = !this.toggled
             // this.$emit('markChange', !this.toggled, this)
          } else {
            this.$message.success('槽位标记失败')
          }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.switchWrapper{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 8px auto;
}

.switch {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  user-select: none;
  font-size: 10px;
  cursor: pointer;

  .switch-input {
    display: none;
  }

  .switch-label {
    position: absolute;
    top: 0;
    font-weight: 600;
    color: white;

    z-index: 2;

    &.label-left {
      left: 10px;
      line-height: 20px;
      border-top-left-radius: 2px;
      border-bottom-left-radius:2px;
    }

    &.label-right {
      right: 10px;
      line-height: 20px;
      border-top-right-radius: 2px;
      border-bottom-right-radius:2px;
    }
  }

  .switch-core {
    display: block;
    position: relative;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: border-color .3s, background-color .3s;
    user-select: none;
    width: 64px;
    height: 20px;
    border-radius: 4px;
    line-height: 20px;

    .switch-button {
      width: 32px;
      height: 20px;
      display: block;
      position: absolute;
      overflow: hidden;
      top: 0;
      left: 0;
      z-index: 3;
      transform: translate3d(0, 0, 0);
      background-color: #ecf0f5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/switcher/ToggleSwitch.vue